/* eslint no-console:0 */

/**
 * core-js includes "polyfills for ECMAScript up to 2019" (at time of comment)
 * regenerator-runtime allows use of async/await and yield/generator funtions
 * As such, they are not needed until we make use of ES6 or async features.
 * We're using entirely coffee right now.
 * These can be included as we migrate.
 */
// import "core-js/stable";
// import "regenerator-runtime/runtime";

// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// import turbolinks from "turbolinks";
// import activestorage from "@rails/activestorage";
// import channels from "channels";

// gem_assets imports any assets needed from rails gems.
// Currently, just rails_timeago
import "./gem_assets.js.erb";

import "jquery"; // jQuery (1.11.3)

import "@vendor/bower_components/jquery-sticky/jquery.sticky";

// jQuery UI (1.1.12)
import "webpack-jquery-ui/autocomplete";
import "webpack-jquery-ui/sortable";
import "webpack-jquery-ui/effects";

import ujs from "@rails/ujs"; // drop-in replacement for jquery_ujs

// Bootstrap (2.3.2)
import "bootstrap-sass-2/js/bootstrap-transition";
import "bootstrap-sass-2/js/bootstrap-alert";
import "bootstrap-sass-2/js/bootstrap-collapse";
import "bootstrap-sass-2/js/bootstrap-dropdown";
import "bootstrap-sass-2/js/bootstrap-tab";
import "bootstrap-sass-2/js/bootstrap-tooltip";
import "bootstrap-sass-2/js/bootstrap-popover";
import "@vendor/bower_components/bootstrap-jasny/js/bootstrap-fileupload";

import "@vendor/bower_components/caroufredsel/jquery.carouFredSel-6.2.1";
import "@vendor/bower_components/ericmmartin.simplemodal/src/jquery.simplemodal";
import "@vendor/bower_components/FitVids/jquery.fitvids";

// Handlebars setup has been moved to /app/assets/javascripts/handlebars

import "@vendor/bower_components/history.js/scripts/bundled/html4+html5/jquery.history";

// Jquery Plugins
import "@vendor/bower_components/isotope/jquery.isotope";
import "@vendor/bower_components/jquery.dirtyforms/jquery.dirtyforms";
import "@vendor/bower_components/jquery-mousewheel/jquery.mousewheel";
import "@vendor/bower_components/jquery-scrollspy/jquery-scrollspy";
import "@vendor/bower_components/jquery.scrollTo/jquery.scrollTo";
import "@vendor/javascripts/jquery.textareaCounter";
import "@vendor/bower_components/jquery-truncate/jquery.truncate";
import "@vendor/bower_components/jquery-ui-touch-punch/jquery.ui.touch-punch";
import "@vendor/bower_components/jquery-validation/dist/jquery.validate";
import "@vendor/bower_components/jquery-validation/dist/additional-methods";
// import "@vendor/bower_components/placeholders/dist/placeholders.jquery";

// Parsley
import "@vendor/bower_components/parsleyjs/dist/parsley";
import "@assets/javascripts/app/plugins/parsley";

// "libs"
import "@vendor/javascripts/libs/functions";
import "js-cookie";
// import { ResizeSensor } from "css-element-queries"; // see ProvidePlugin

import "@vendor/bower_components/selectize/dist/js/standalone/selectize";
import "@vendor/javascripts/selectize-plugin-a11y";
import "@vendor/bower_components/sisyphus/sisyphus";
import "slick-carousel"; // replaces jquery.slick
// spin.js/spin is aliased through the webpack ProvidePlugin
import "@vendor/bower_components/spin.js/jquery.spin";
import "@vendor/javascripts/jquery.querystring";
import "@vendor/bower_components/chosen/chosen.jquery";
import "moment";

// rails-timeago is included in gem_assets.js.erb

import "@assets/javascripts/livesearch.coffee";
import "underscore";

import "@vendor/bower_components/URIjs/src/URI.js";

import "magnific-popup";

import smoothscroll from 'smoothscroll-polyfill';

/**
 * The following *.tree files replicate the behavior of sprockets require_tree
 * Each file manually includes scripts for it's respective directory.
 * This approach allows for continued sprockets require_tree support,
 * vs using an index.js file in each directory.
 */
import "@assets/javascripts/analytics/lesson_views.js.coffee"; //= require_tree ./analytics
import "@assets/javascripts/app.tree"; // require_tree ./app
import "@assets/javascripts/ui.tree"; // require_tree ./ui
import "@assets/javascripts/lessons.tree"; // require_tree ./lessons
import "@assets/javascripts/series.tree"; // require_tree ./series
import "@assets/javascripts/lesson_activities.tree"; // require_tree ./lesson_activities

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

ujs.start();

/*
TODO: Refactor/remove.
  This is holdover from the original implementation of the site. We should
  replace/remove it – cs
*/
for (var i in App) {
  if (typeof App[i].initialize == "function") {
    App[i].initialize && App[i].initialize();
  }
}

// Add title attribute to chosen dropdown search filter
// for accessibility.
$("body").on("chosen:ready", function() {
  $(".chosen-search")
    .find("input")
    .attr("title", "filter options");
});

smoothscroll.polyfill();

// We have to expose App globally for rails-ujs executions.
global.App = App;
